import { render, staticRenderFns } from "./page-promo-banners.vue?vue&type=template&id=0e26c5a3&"
import script from "./page-promo-banners.vue?vue&type=script&lang=js&"
export * from "./page-promo-banners.vue?vue&type=script&lang=js&"
import style0 from "./page-promo-banners.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SlideDownTransition: require('/opt/build/repo/storefront/components/atoms/Transition/SlideDownTransition.vue').default})
